<template>
    <v-dialog :value="value" @input="$emit('input', $event)" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ $t('ticket.checklist.fulfillChecklist') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="saveChecklist" :loading="loadingChecklist"
                        :disabled="!checklistFormValidado || loadingChecklist">
                        {{ $t('button.save') }}
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text>
                <LoadingComponent :loading="loadingChecklistDetails" :message="loadingMessage" style="z-index: 1000;" />
                <v-container v-if="!loadingChecklistDetails">
                    <v-form ref="checklistForm" v-model="checklistFormValidado">
                        <!-- Choose checklist to fill (when service has multiple checklists) -->
                        <v-card style="margin-bottom: 15px;" v-if="ticket && checklistsServicoOptions.length > 1">
                            <v-card-title style="color: #4a4a4a;">{{ $t('ticket.checklist.chooseChecklistToFill') }}</v-card-title>
                            <v-card-text>
                                <v-select
                                    v-model="checklistToFillId"
                                    :items="checklistsServicoOptions"
                                    item-text="nome_checklist"
                                    item-value="id_checklist_equipamento"
                                    :label="$t('ticket.checklist.chooseChecklistToFill')"
                                    outlined
                                    dense
                                    @change="loadChecklistForFulfillDialog"
                                ></v-select>
                            </v-card-text>
                        </v-card>
                        <!-- Checklist Info (Read-only) -->
                        <v-card style="margin-bottom: 15px;" v-if="ticket">
                            <v-card-title style="color: #4a4a4a;">{{ $t('ticket.checklist.ticketInfo') }}</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <div><strong>{{ $t('ticket.headers.title') }}:</strong> {{ ticket.titulo }}</div>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <div><strong>{{ $t('ticket.checklist.checklist') }}:</strong> {{ checklistSelecionado?.nome_checklist || '-' }}</div>
                                    </v-col>
                                    <template v-if="checklistSelecionado">
                                        <v-col cols="12" sm="12" md="6">
                                            <v-text-field :value="user && user.nome_usuario" outlined
                                                :label="$t('equipmentChecklist.responsibleEmployee')" readonly disabled></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-datetime-picker :label="$t('equipmentChecklist.realizationDateTime')"
                                                v-model="checklistItem.dt_realizacao"
                                                :time-picker-props="checklistTimeProps"
                                                :text-field-props="checklistTextFieldProps" time-format="HH:mm:ss"
                                                date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                                                <template slot="dateIcon">
                                                    <v-icon>mdi-calendar</v-icon>
                                                </template>
                                                <template slot="timeIcon">
                                                    <v-icon>mdi-clock</v-icon>
                                                </template>
                                            </v-datetime-picker>
                                        </v-col>
                                    </template>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- Checklist Fields -->
                        <v-card style="margin-bottom: 15px;" v-if="checklistSelecionado && checklistSelecionado.campos">
                            <v-card-title style="color: #4a4a4a;">{{ $t('equipmentChecklist.fillFields') }}</v-card-title>
                            <v-card-text>
                                <v-row v-for="campo in checklistSelecionado.campos" :key="campo.id_campo" style="margin-bottom: 10px;">
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field v-if="campo.tipo === 'Text'" v-model="checklistValoresCampos[campo.id_campo]"
                                            :label="campo.label + (campo.obrigatorio ? ' *' : '')" outlined
                                            :rules="campo.obrigatorio ? [validaCampoChecklist] : []"></v-text-field>
                                        <v-text-field v-else-if="campo.tipo === 'Number'" v-model.number="checklistValoresCampos[campo.id_campo]"
                                            :label="campo.label + (campo.obrigatorio ? ' *' : '')" outlined type="number"
                                            :rules="campo.obrigatorio ? [validaCampoChecklist] : []"></v-text-field>
                                        <v-menu v-else-if="campo.tipo === 'Date'" v-model="checklistMenuDate[campo.id_campo]"
                                            :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="checklistValoresCampos[campo.id_campo]"
                                                    :label="campo.label + (campo.obrigatorio ? ' *' : '')" outlined readonly v-bind="attrs" v-on="on"
                                                    :rules="campo.obrigatorio ? [validaCampoChecklist] : []"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="checklistValoresCampos[campo.id_campo]"
                                                @input="checklistMenuDate[campo.id_campo] = false" locale="pt-BR"></v-date-picker>
                                        </v-menu>
                                        <v-select v-else-if="campo.tipo === 'Select'" v-model="checklistValoresCampos[campo.id_campo]"
                                            :items="campo.opcoes || []" :label="campo.label + (campo.obrigatorio ? ' *' : '')" outlined
                                            :rules="campo.obrigatorio ? [validaCampoChecklist] : []"></v-select>
                                        <v-checkbox v-else-if="campo.tipo === 'Checkbox'" v-model="checklistValoresCampos[campo.id_campo]"
                                            :label="campo.label + (campo.obrigatorio ? ' *' : '')"
                                            :rules="campo.obrigatorio ? [validaCampoCheckboxChecklist] : []"></v-checkbox>
                                        <v-textarea v-else-if="campo.tipo === 'Textarea'" v-model="checklistValoresCampos[campo.id_campo]"
                                            :label="campo.label + (campo.obrigatorio ? ' *' : '')" outlined rows="3"
                                            :rules="campo.obrigatorio ? [validaCampoChecklist] : []"></v-textarea>
                                        <div v-else-if="campo.tipo === 'Photo'">
                                            <v-file-input v-model="checklistPhotoFiles[campo.id_campo]"
                                                :label="campo.label + (campo.obrigatorio ? ' *' : '')" outlined
                                                accept="image/jpeg,image/jpg,image/png,image/gif,image/webp" prepend-icon="mdi-camera"
                                                :rules="campo.obrigatorio ? [validaCampoPhotoChecklist, validaCampoPhotoTypeChecklist] : [validaCampoPhotoTypeChecklist]"
                                                @change="onChecklistPhotoChange($event, campo.id_campo)" show-size :max-size="5242880"></v-file-input>
                                            <v-img v-if="checklistPhotoPreviews[campo.id_campo]"
                                                :key="'photo-preview-' + campo.id_campo + '-' + (checklistPhotoPreviewVersion[campo.id_campo] || 0)"
                                                :src="checklistPhotoPreviews[campo.id_campo]" max-height="200" max-width="300" contain class="mt-2"></v-img>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-alert v-if="!checklistSelecionado.campos || checklistSelecionado.campos.length === 0" type="info" outlined>
                                    {{ $t('equipmentChecklist.noFieldsAvailable') }}
                                </v-alert>
                            </v-card-text>
                        </v-card>

                        <!-- Observations -->
                        <v-card style="margin-bottom: 15px;" v-if="checklistSelecionado">
                            <v-card-title style="color: #4a4a4a;">{{ $t('equipmentChecklist.observations') }}</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <v-textarea v-model="checklistItem.observacoes" outlined rows="3"
                                            :label="$t('equipmentChecklist.observations')" counter maxlength="1000"></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- Additional photos, videos and ZIP -->
                        <v-card style="margin-bottom: 15px;" v-if="checklistSelecionado">
                            <v-card-title style="color: #4a4a4a;">{{ $t('equipmentChecklist.additionalPhotos') }}</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <v-file-input ref="checklistExtraPhotoInput"
                                            accept="image/jpeg,image/jpg,image/png,image/gif,image/webp,video/mp4,video/quicktime,video/x-msvideo,video/webm,application/zip,.zip"
                                            prepend-icon="mdi-camera" :label="$t('equipmentChecklist.additionalPhotos')" outlined show-size
                                            :max-size="104857600" @change="onChecklistExtraPhotoAdd" clearable style="max-width: 400px;"></v-file-input>
                                        <div class="caption grey--text mb-2">{{ $t('equipmentChecklist.additionalMediaHint') }}</div>
                                        <v-row v-if="checklistExtraExistingPaths.length + checklistExtraNewFiles.length > 0" class="mt-2">
                                            <v-col v-for="(item, idx) in checklistExtraPhotoPreviewsList" :key="'extra-' + idx" cols="6" sm="4" md="3">
                                                <div class="d-flex flex-column align-center">
                                                    <template v-if="item.mediaType === 'video'">
                                                        <div class="rounded overflow-hidden grey lighten-2" style="max-height: 120px; max-width: 160px;">
                                                            <video v-if="item.src" :src="item.src" muted playsinline preload="metadata"
                                                                style="max-height: 120px; max-width: 160px; width: 100%; height: auto; object-fit: contain;"
                                                                class="rounded" @click="openPhoto(item.src)"></video>
                                                            <div v-else class="d-flex align-center justify-center" style="min-height: 120px; min-width: 160px;">
                                                                <v-icon large>mdi-video</v-icon>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template v-else-if="item.mediaType === 'zip'">
                                                        <div class="rounded grey lighten-2 d-flex align-center justify-center" style="min-height: 120px; min-width: 160px;">
                                                            <v-icon large>mdi-folder-zip</v-icon>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <v-img :src="item.src" max-height="120" max-width="160" contain class="rounded"></v-img>
                                                    </template>
                                                    <v-btn x-small color="error" text @click="removeChecklistExtraPhoto(idx)" class="mt-1">{{ $t('button.remove') }}</v-btn>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import apiController from '@/utils/apiController';
import { ApiBaseUrl } from '@/constants';
import EventBus from '../../utils/eventBus';
import LoadingComponent from '../LoadingComponent.vue';

export default {
    name: 'ChecklistFulfillmentDialog',
    components: { LoadingComponent },
    props: {
        value: { type: Boolean, default: false },
        ticket: { type: Object, default: null },
        token: { type: String, default: '' },
        user: { type: Object, default: null },
        checklists: { type: Array, default: () => [] }
    },
    data() {
        return {
            checklistFormValidado: false,
            checklistToFillId: null,
            loadingChecklistDetails: false,
            loadingChecklist: false,
            loadingMessage: '',
            checklistSelecionado: null,
            checklistItem: {
                id_checklist_equipamento: null,
                id_funcionario_responsavel: null,
                observacoes: null,
                dt_realizacao: new Date()
            },
            checklistValoresCampos: {},
            checklistValoresEditedBy: {},
            checklistValoresCamposOriginal: {},
            checklistMenuDate: {},
            checklistPhotoFiles: {},
            checklistPhotoPreviews: {},
            checklistExtraExistingPaths: [],
            checklistExtraNewFiles: [],
            checklistPhotoPendingRead: {},
            checklistPhotoPreviewVersion: {},
            funcionarios: []
        };
    },
    computed: {
        checklistsServicoOptions() {
            if (!this.ticket || !this.ticket.ids_checklists_servico) return [];
            const idsStr = this.ticket.ids_checklists_servico;
            const ids = typeof idsStr === 'string' ? idsStr.split(',').map(s => Number(String(s).trim())).filter(n => !isNaN(n)) : (idsStr || []);
            return ids.map(id => {
                const c = (this.checklists || []).find(cl => Number(cl.id_checklist_equipamento) === id);
                return c ? { id_checklist_equipamento: c.id_checklist_equipamento, nome_checklist: c.nome_checklist } : { id_checklist_equipamento: id, nome_checklist: String(id) };
            });
        },
        checklistExtraPhotoPreviewsList() {
            const list = [];
            (this.checklistExtraExistingPaths || []).forEach(path => {
                list.push({ src: this.getPhotoUrl(path), isExisting: true, mediaType: this.getChecklistMediaTypeFromPath(path) });
            });
            (this.checklistExtraNewFiles || []).forEach(item => {
                list.push({ src: item.preview, isExisting: false, mediaType: item.mediaType || 'image' });
            });
            return list;
        },
        checklistTimeProps() {
            return { useSeconds: true };
        },
        checklistTextFieldProps() {
            return { prependIcon: 'mdi-calendar' };
        },
        currentUserId() {
            if (!this.user) return null;
            return this.user.id_usuario !== undefined && this.user.id_usuario !== null ? this.user.id_usuario : this.user.id;
        }
    },
    watch: {
        value(open) {
            if (open && this.ticket) {
                const idsStr = this.ticket.ids_checklists_servico;
                const ids = idsStr ? (typeof idsStr === 'string' ? idsStr.split(',') : idsStr).map(s => Number(String(s).trim())).filter(n => !isNaN(n)) : [];
                if (ids.length > 0) {
                    const defaultId = this.ticket.id_checklist_equipamento && ids.includes(Number(this.ticket.id_checklist_equipamento)) ? Number(this.ticket.id_checklist_equipamento) : ids[0];
                    this.checklistToFillId = defaultId;
                } else {
                    this.checklistToFillId = this.ticket.id_checklist_equipamento || null;
                }
                this.loadingChecklistDetails = true;
                this.loadingMessage = this.$t('system.messages.loading');
                this.resetChecklistState();
                this.populaFuncionarios();
                if (this.checklistToFillId) {
                    this.loadChecklistForFulfillDialog(this.checklistToFillId);
                } else {
                    this.loadingChecklistDetails = false;
                    EventBus.$emit('show-alert', { mensagem: this.$t('equipmentChecklist.checklistNotFound'), tipo: 'error' });
                    this.close();
                }
            }
        },
        ticket(t) {
            if (this.value && t) {
                const idsStr = t.ids_checklists_servico;
                const ids = idsStr ? (typeof idsStr === 'string' ? idsStr.split(',') : idsStr).map(s => Number(String(s).trim())).filter(n => !isNaN(n)) : [];
                this.checklistToFillId = ids.length > 0 ? (t.id_checklist_equipamento && ids.includes(Number(t.id_checklist_equipamento)) ? Number(t.id_checklist_equipamento) : ids[0]) : (t.id_checklist_equipamento || null);
                if (this.checklistToFillId) this.loadChecklistForFulfillDialog(this.checklistToFillId);
            }
        }
    },
    methods: {
        validaCampoChecklist(v) {
            return !!v || this.$t('validation.required');
        },
        validaCampoCheckboxChecklist(v) {
            return (v !== undefined && v !== null) || this.$t('validation.required');
        },
        validaCampoPhotoChecklist(v) {
            if (!v || (Array.isArray(v) && v.length === 0)) return this.$t('validation.required');
            return true;
        },
        validaCampoPhotoTypeChecklist(v) {
            if (!v || (Array.isArray(v) && v.length === 0)) return true;
            const file = Array.isArray(v) ? v[0] : v;
            if (!['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'].includes(file.type)) return this.$t('equipmentChecklist.invalidImageType');
            if (file.size > 5242880) return this.$t('equipmentChecklist.imageTooLarge');
            return true;
        },
        getPhotoUrl(path) {
            if (!path) return '';
            if (path.startsWith('http://') || path.startsWith('https://')) return path;
            let cleanPath = path;
            if (cleanPath.startsWith('static/uploads/')) cleanPath = cleanPath.substring(7);
            else if (cleanPath.startsWith('static/')) cleanPath = cleanPath.substring(7);
            if (!cleanPath.startsWith('/')) cleanPath = '/' + cleanPath;
            return `${ApiBaseUrl}${cleanPath}`;
        },
        getChecklistMediaTypeFromPath(path) {
            if (!path || typeof path !== 'string') return 'image';
            const p = path.toLowerCase();
            if (/\.(mp4|mov|avi|webm)$/.test(p)) return 'video';
            if (/\.zip$/.test(p)) return 'zip';
            return 'image';
        },
        openPhoto(url) {
            window.open(url, '_blank');
        },
        onChecklistPhotoChange(file, campoId) {
            if (!file || (Array.isArray(file) && file.length === 0)) {
                if (!this.checklistPhotoPendingRead[campoId]) this.$set(this.checklistPhotoPreviews, campoId, null);
                this.$set(this.checklistValoresCampos, campoId, null);
                return;
            }
            const selectedFile = Array.isArray(file) ? file[0] : file;
            if (selectedFile && selectedFile instanceof File) {
                this.$set(this.checklistPhotoPendingRead, campoId, true);
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.$set(this.checklistPhotoPreviews, campoId, e.target.result);
                    this.$set(this.checklistPhotoPreviewVersion, campoId, (this.checklistPhotoPreviewVersion[campoId] || 0) + 1);
                    this.$set(this.checklistPhotoPendingRead, campoId, false);
                };
                reader.onerror = () => this.$set(this.checklistPhotoPendingRead, campoId, false);
                reader.readAsDataURL(selectedFile);
                this.$set(this.checklistValoresCampos, campoId, null);
            }
        },
        revokeChecklistExtraVideoUrls() {
            (this.checklistExtraNewFiles || []).forEach(item => {
                if (item && item.mediaType === 'video' && item.preview && typeof item.preview === 'string' && item.preview.startsWith('blob:')) URL.revokeObjectURL(item.preview);
            });
        },
        onChecklistExtraPhotoAdd(file) {
            if (!file || (Array.isArray(file) && file.length === 0)) return;
            const f = Array.isArray(file) ? file[0] : file;
            const isVideo = /^video\//.test(f.type);
            const isZip = f.type === 'application/zip' || f.type === 'application/x-zip-compressed' || (f.name && /\.zip$/i.test(f.name));
            const mediaType = isVideo ? 'video' : isZip ? 'zip' : 'image';
            if (mediaType === 'image') {
                const reader = new FileReader();
                reader.onload = (e) => this.checklistExtraNewFiles.push({ file: f, preview: e.target.result, mediaType: 'image' });
                reader.readAsDataURL(f);
            } else if (mediaType === 'video') {
                this.checklistExtraNewFiles.push({ file: f, preview: URL.createObjectURL(f), mediaType: 'video' });
            } else {
                this.checklistExtraNewFiles.push({ file: f, preview: null, mediaType: 'zip' });
            }
            if (this.$refs.checklistExtraPhotoInput) this.$refs.checklistExtraPhotoInput.reset();
        },
        removeChecklistExtraPhoto(index) {
            if (index < this.checklistExtraExistingPaths.length) this.checklistExtraExistingPaths.splice(index, 1);
            else {
                const newIdx = index - this.checklistExtraExistingPaths.length;
                const item = this.checklistExtraNewFiles[newIdx];
                if (item && item.mediaType === 'video' && item.preview && item.preview.startsWith('blob:')) URL.revokeObjectURL(item.preview);
                this.checklistExtraNewFiles.splice(newIdx, 1);
            }
        },
        resetChecklistState() {
            this.checklistSelecionado = null;
            this.checklistItem = { id_checklist_equipamento: null, id_funcionario_responsavel: null, observacoes: null, dt_realizacao: new Date() };
            this.checklistValoresCampos = {};
            this.checklistValoresEditedBy = {};
            this.checklistValoresCamposOriginal = {};
            this.checklistMenuDate = {};
            this.checklistPhotoFiles = {};
            this.checklistPhotoPreviews = {};
            this.checklistExtraExistingPaths = [];
            this.revokeChecklistExtraVideoUrls();
            this.checklistExtraNewFiles = [];
            this.checklistPhotoPendingRead = {};
            this.checklistPhotoPreviewVersion = {};
            if (this.$refs.checklistForm) this.$refs.checklistForm.resetValidation();
        },
        close() {
            this.resetChecklistState();
            this.$emit('input', false);
        },
        async loadChecklistForFulfillDialog(selectedId) {
            if (!this.ticket) return;
            this.loadingChecklistDetails = true;
            this.checklistItem = { id_checklist_equipamento: selectedId, id_funcionario_responsavel: this.currentUserId, observacoes: null, dt_realizacao: new Date() };
            this.checklistValoresCampos = {};
            this.checklistValoresEditedBy = {};
            this.checklistValoresCamposOriginal = {};
            this.checklistMenuDate = {};
            this.checklistPhotoFiles = {};
            this.checklistPhotoPreviews = {};
            this.checklistExtraExistingPaths = [];
            this.revokeChecklistExtraVideoUrls();
            this.checklistExtraNewFiles = [];
            this.checklistPhotoPendingRead = {};
            this.checklistPhotoPreviewVersion = {};
            this.checklistSelecionado = null;
            try {
                const response = await apiController.request(apiController.endpoints.getChecklistequipamentoporid, { params: { id: selectedId }, silent: true });
                if (response.data && !response.data.erro) {
                    this.checklistSelecionado = response.data;
                    if (this.checklistSelecionado.campos) {
                        this.checklistSelecionado.campos.forEach(campo => {
                            this.$set(this.checklistValoresCampos, campo.id_campo, campo.tipo === 'Checkbox' ? false : null);
                            this.$set(this.checklistMenuDate, campo.id_campo, false);
                            if (campo.tipo === 'Photo') {
                                this.$set(this.checklistPhotoFiles, campo.id_campo, null);
                                this.$set(this.checklistPhotoPreviews, campo.id_campo, null);
                            }
                        });
                    }
                    if (this.ticket.id_ticket) {
                        const res2 = await apiController.request(apiController.endpoints.getChecklistequipamentorespostaporticket, { params: { id_ticket: this.ticket.id_ticket }, query: { id_checklist_equipamento: selectedId }, silent: true });
                        if (res2.data && res2.data.dados) {
                            const dados = res2.data.dados;
                            this.$set(this.checklistItem, 'id_resposta', dados.id_resposta);
                            this.checklistItem.observacoes = dados.observacoes;
                            this.checklistItem.dt_realizacao = dados.dt_realizacao ? new Date(dados.dt_realizacao) : new Date();
                            if (dados.valores && Array.isArray(dados.valores) && this.checklistSelecionado.campos) {
                                const original = {};
                                dados.valores.forEach(v => {
                                    const campoDef = this.checklistSelecionado.campos.find(c => c.id_campo === v.id_campo);
                                    if (campoDef) {
                                        original[v.id_campo] = v.valor == null ? null : String(v.valor);
                                        if (campoDef.tipo === 'Checkbox') this.$set(this.checklistValoresCampos, v.id_campo, v.valor === 'true');
                                        else if (campoDef.tipo === 'Photo' && v.valor) {
                                            this.$set(this.checklistValoresCampos, v.id_campo, v.valor);
                                            this.$set(this.checklistPhotoPreviews, v.id_campo, this.getPhotoUrl(v.valor));
                                        } else this.$set(this.checklistValoresCampos, v.id_campo, v.valor);
                                    }
                                });
                                this.checklistValoresCamposOriginal = original;
                            }
                            this.checklistExtraExistingPaths = Array.isArray(dados.fotos_extra) ? [...dados.fotos_extra] : [];
                            this.checklistExtraNewFiles = [];
                        } else {
                            this.checklistExtraExistingPaths = [];
                            this.checklistExtraNewFiles = [];
                        }
                    } else {
                        this.checklistExtraExistingPaths = [];
                        this.checklistExtraNewFiles = [];
                    }
                } else {
                    EventBus.$emit('show-alert', { mensagem: this.$t('equipmentChecklist.loadError'), tipo: 'error' });
                    this.close();
                }
            } catch (e) {
                EventBus.$emit('show-error', { mensagem: this.$t('equipmentChecklist.loadError'), tipo: 'error' });
                this.close();
            } finally {
                this.loadingChecklistDetails = false;
            }
        },
        populaFuncionarios() {
            apiController.request(apiController.endpoints.getallFuncionarios, {
                onSuccess: (response) => { this.funcionarios = response.data || []; },
                onError: () => { this.funcionarios = []; },
                silent: true,
            });
        },
        findFuncionarioByUserName() {
            if (!this.user || !this.user.nome_usuario || !this.funcionarios || this.funcionarios.length === 0) {
                return null;
            }
            const userName = (this.user.nome_usuario || '').trim().toLowerCase();
            const funcionario = this.funcionarios.find(f => {
                if (!f) return false;
                if (f.nome && f.nome.trim().toLowerCase() === userName) return true;
                if (f.nome_completo && f.nome_completo.trim().toLowerCase() === userName) return true;
                if (f.descricao) {
                    const namePart = f.descricao.trim().toLowerCase().split(' ').slice(1).join(' ');
                    if (namePart === userName) return true;
                }
                return false;
            });
            return funcionario ? funcionario.id_funcionario : null;
        },
        formatDateLocalForAPI(dateValue) {
            if (!dateValue) return null;
            const d = dateValue instanceof Date ? dateValue : new Date(dateValue);
            if (isNaN(d.getTime())) return null;
            const pad = n => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        },
        uploadChecklistPhoto(campoId) {
            return new Promise((resolve, reject) => {
                const file = this.checklistPhotoFiles[campoId];
                if (!file || (Array.isArray(file) && file.length === 0)) { resolve(null); return; }
                const selectedFile = Array.isArray(file) ? file[0] : file;
                if (!selectedFile) { resolve(null); return; }
                const filename = `checklist_${this.checklistItem.id_checklist_equipamento}_campo_${campoId}_${Date.now()}`;
                const reader = new FileReader();
                reader.onload = (e) => {
                    apiController.request(apiController.endpoints.uploadImg, {
                        data: { file: e.target.result, filename, folder: 'checklists_equipamentos' },
                        silent: true,
                        onSuccess: (response) => response.data && !response.data.error && response.data.path ? resolve(response.data.path) : reject(new Error(response.data?.message)),
                        onError: reject,
                    });
                };
                reader.onerror = () => reject(new Error('Failed to read file'));
                reader.readAsDataURL(selectedFile);
            });
        },
        uploadChecklistExtraPhotos() {
            if (!this.checklistExtraNewFiles || this.checklistExtraNewFiles.length === 0) return Promise.resolve([]);
            const idChecklist = this.checklistItem.id_checklist_equipamento;
            const timestamp = Date.now();
            return Promise.all(this.checklistExtraNewFiles.map((item, idx) => {
                const file = item.file;
                const filename = `checklist_${idChecklist}_extra_${idx}_${timestamp}`;
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        apiController.request(apiController.endpoints.uploadChecklistmedia, {
                            data: { file: e.target.result, filename, folder: 'checklists_equipamentos' },
                            silent: true,
                            onSuccess: (response) => response.data && !response.data.error && response.data.path ? resolve(response.data.path) : reject(new Error(response.data?.message || 'Upload failed')),
                            onError: reject,
                        });
                    };
                    reader.onerror = () => reject(new Error('Failed to read file'));
                    reader.readAsDataURL(file);
                });
            }));
        },
        async saveChecklist() {
            this.$refs.checklistForm.validate();
            if (!this.checklistFormValidado) {
                EventBus.$emit('show-alert', { tipo: 'warning', mensagem: this.$t('ticket.alerts.warning.formErrorsSave') });
                return;
            }
            if (!this.checklistSelecionado || !this.checklistSelecionado.campos) {
                EventBus.$emit('show-alert', { mensagem: this.$t('equipmentChecklist.loadError'), tipo: 'error' });
                return;
            }
            const camposObrigatorios = this.checklistSelecionado.campos.filter(c => c.obrigatorio);
            const camposInvalidos = camposObrigatorios.filter(c => {
                if (c.tipo === 'Photo') return !this.checklistPhotoFiles[c.id_campo] || (Array.isArray(this.checklistPhotoFiles[c.id_campo]) && this.checklistPhotoFiles[c.id_campo].length === 0);
                const valor = this.checklistValoresCampos[c.id_campo];
                return valor === null || valor === undefined || valor === '';
            });
            if (camposInvalidos.length > 0) {
                EventBus.$emit('show-alert', { mensagem: this.$t('equipmentChecklist.requiredFieldsMissing'), tipo: 'warning' });
                return;
            }
            this.loadingChecklist = true;
            this.loadingMessage = this.$t('system.messages.uploadingPhotos');
            const photoUploadPromises = this.checklistSelecionado.campos.filter(c => c.tipo === 'Photo').map(campo =>
                this.uploadChecklistPhoto(campo.id_campo).then(path => { if (path) this.checklistValoresCampos[campo.id_campo] = path; return { campoId: campo.id_campo, path }; })
            );
            try {
                await Promise.all(photoUploadPromises);
                const extraPaths = await this.uploadChecklistExtraPhotos();
                const fotos_extra = [...(this.checklistExtraExistingPaths || []), ...(extraPaths || [])];
                const normalizeValorForCampo = (campo, valor) => {
                    if (valor === null || valor === undefined) return null;
                    if (campo.tipo === 'Checkbox') return valor ? 'true' : 'false';
                    if (campo.tipo === 'Date' && valor) return String(valor);
                    return String(valor);
                };
                const allValores = this.checklistSelecionado.campos.map(campo => ({ id_campo: campo.id_campo, valor: normalizeValorForCampo(campo, this.checklistValoresCampos[campo.id_campo]) }));
                const valores = this.checklistItem.id_resposta
                    ? allValores.filter(v => { const o = this.checklistValoresCamposOriginal[v.id_campo]; const origNorm = o === undefined || o === null ? null : String(o); return v.valor !== origNorm; })
                    : allValores;
                let dtRealizacao = null;
                if (this.checklistItem.dt_realizacao) dtRealizacao = typeof this.checklistItem.dt_realizacao === 'string' ? this.checklistItem.dt_realizacao : this.formatDateLocalForAPI(new Date(this.checklistItem.dt_realizacao));
                const payload = {
                    id_resposta: this.checklistItem.id_resposta,
                    id_checklist_equipamento: this.checklistItem.id_checklist_equipamento,
                    id_equipamentos: [],
                    equipamentos_info: [],
                    id_tipo_kit: null,
                    id_funcionario_responsavel: this.findFuncionarioByUserName(),
                    observacoes: this.checklistItem.observacoes || null,
                    dt_realizacao: dtRealizacao,
                    valores,
                    fotos_extra,
                    id_ticket: this.ticket ? this.ticket.id_ticket : null,
                    id_usuario_alteracao: this.currentUserId
                };
                this.loadingMessage = this.$t('system.messages.saving');
                const endpoint = this.checklistItem.id_resposta ? apiController.endpoints.updateChecklistequipamentoresposta : apiController.endpoints.insertChecklistequipamentoresposta;
                const response = await apiController.request(endpoint, { data: payload, silent: true });
                if (response.data.erro) {
                    this.loadingChecklist = false;
                    EventBus.$emit('show-alert', { mensagem: this.$t('equipmentChecklist.saveError'), tipo: 'error' });
                    return;
                }
                const comentarioTexto = `${this.$t('equipmentChecklist.checklist')} "${this.checklistSelecionado.nome_checklist}" ${this.$t('equipmentChecklist.wasFilled')}.`;
                apiController.request(apiController.endpoints.insertComentario, { data: { id_ticket: this.ticket.id_ticket, corpo: comentarioTexto, id_usuario_comentario: this.currentUserId }, silent: true }).catch(() => {});
                this.loadingChecklist = false;
                EventBus.$emit('show-alert', { mensagem: this.$t('equipmentChecklist.saveSuccess'), tipo: 'success' });
                this.close();
                this.$emit('saved');
            } catch (e) {
                this.loadingChecklist = false;
                EventBus.$emit('show-error', { mensagem: this.$t('equipmentChecklist.saveError'), tipo: 'error' });
            }
        }
    }
};
</script>
